import FormType from '../../constants/form-type';
import PasswordMode from '../../constants/password-mode';

class ModelStore extends EventEmitter {
    constructor() {
        super();

        this.CHANGE_EVENT = 'MODEL_CHANGE_EVENT';

        this._model = {};
    }

    registerComponent(componentId) {
        this._model[`c${componentId}`] = {
            formType: FormType.login,
            email: '',
            password: '',
            confirmedPassword: '',
            passwordMode: PasswordMode.standard,
            keepLoggedIn: false,
            acceptTerms: false,
            sendProductInformation: true,
            validation: this.emptyValidationModel
        };
    }

    getModel(componentId) {

        if (componentId === undefined || componentId === null) {
            throw new Error('componentId is missing');
        }

        return this._model[`c${componentId}`];
    }

    get emptyValidationModel() {
        return {
            errors: {
                email: '',
                password: '',
                confirmedPassword: '',
                acceptTerms: '',
                submitError: ''
            },
            hasErrors: false,
            hasEmailBeenEdited: false,
            hasEmailBeenValid: false,
            hasPasswordBeenEdited: false,
            hasPasswordBeenValid: false,
            hasConfirmedPasswordBeenEdited: false,
            hasConfirmedPasswordBeenValid: false
        };
    }

    addChangeListener(callback) {
        this.on(this.CHANGE_EVENT, callback);
    }

    removeChangeListener(callback) {
        this.removeListener(this.CHANGE_EVENT, callback);
    }

    update(componentId, updateFn) {
        if (updateFn) {
            updateFn(this.getModel(componentId));
        }

        this.emit(this.CHANGE_EVENT);
    }

    updateAsync(componentId, updateFn) {
        var promise = updateFn(this.getModel(componentId)).then(() => {
            this.emit(this.CHANGE_EVENT);
        });

        this.emit(this.CHANGE_EVENT);

        return promise;
    }
}

let modelStore = new ModelStore();
modelStore.setMaxListeners(1000000);
export default modelStore;



/** WEBPACK FOOTER **
 ** ./src/logic/stores/model-store.js
 **/